import { ListCategory } from "./ListCategory";
import { TextBoxCategory } from "./TextBoxCategory";
import { SWOTCategory } from "./SWOTCategory";
import { PillarCategory } from "./PillarCategory";
import { OrgChartCategory } from "./OrgChartCategory";
import { HeatMapCategory } from "./HeatMapCategory";
import { KeyConceptCategory } from "./KeyConceptCategory";
import { QuoteCategory } from "./QuoteCategory";
import { HeadlineCategory } from "./HeadlineCategory";
import { ComparisonCategory } from "./ComparisonCategory";
import { FactoidCategory } from "./FactoidCategory";
import { TextCategory } from "./TextCategory";
import { TitleCategory } from "./TitleCategory";
import { TableCategory } from "./TableCategory";
import { TimelineCategory } from "./TimelineCategory";
import { FlowDiagramCategory } from "./FlowDiagramCategory";
import { BeforeAfterCategory } from "./BeforeAfterCategory";
import { PhotoCategory, PhotosWithTextCategory } from "./PhotosWithTextCategory";
import { TeamCategory } from "./TeamCategory";
import { BiographyCategory } from "./BiographyCategory";
import { ProductScreenshotCategory } from "./ProductScreenshotCategory";
import { ChartCategory } from "./ChartCategory";
import { DashboardCategory } from "./DashboardCategory";
import { QuadrantChartCategory } from "./QuadrantChartCategory";
import { FunnelCategory } from "./FunnelCategory";
import { FlowChartCategory } from "./FlowChartCategory";
import { AgendaCategory } from "./AgendaCategory";
import { TargetCategory } from "./TargetCategory";
import { HierarchyDiagramCategory } from "./HierarchyDiagramCategory";
import { ContactInfoCategory } from "./ContactInfoCategory";
import { LogoGridCategory } from "./LogoGridCategory";
import { VennDiagramCategory } from "./VennDiagramCategory";

export const SlideCategories = {
    TITLE: "title",
    TEXT: "text",
    LIST: "list",
    QUOTE: "quote",
    HEADLINE: "headline",
    // KEY_CONCEPT: "key_concept",
    DASHBOARD: "dashboard",
    // FACTOID: "factoid",
    // TEXT_BOX: "text_box",
    SWOT: "swot",
    PILLAR: "pillar",
    ORG_CHART: "org_chart",
    HEAT_MAP: "heatmap",
    TABLE: "table",
    TIMELINE: "timeline",
    FLOW_DIAGRAM: "flow_diagram",
    BEFORE_AFTER: "before_after",
    PHOTOS_WITH_TEXT: "photos_with_text",
    TEAM: "team",
    BIOGRAPHY: "biography",
    // PRODUCT_SCREENSHOT: "product_screenshot",
    COMPARISON: "comparison",
    CHART: "chart",
    PIE_CHART: "pie_chart",
    QUADRANT_CHART: "quadrant_chart",
    FUNNEL: "funnel",
    FLOWCHART: "flowchart",
    AGENDA: "agenda",
    TARGET: "target",
    HIERARCHY_DIAGRAM: "hierarchy_diagram",
    CONTACT_INFO: "contact_info",
    LOGO_GRID: "logo_grid",
    VENN_DIAGRAM: "venn_diagram",

    // THANKYOU: "thankyou",
    // CONTACT: "contact",
};

export class CategoryController {
    static getCategory(type) {
        switch (type) {
            case SlideCategories.LIST:
                return new ListCategory();
            // case SlideCategories.TEXT_BOX:
            //     return new TextBoxCategory();
            case SlideCategories.SWOT:
                return new SWOTCategory();
            case SlideCategories.PILLAR:
                return new PillarCategory();
            case SlideCategories.ORG_CHART:
                return new OrgChartCategory();
            case SlideCategories.HEAT_MAP:
                return new HeatMapCategory();
            // case SlideCategories.KEY_CONCEPT:
            //     return new KeyConceptCategory();
            case SlideCategories.QUOTE:
                return new QuoteCategory();
            case SlideCategories.HEADLINE:
                return new HeadlineCategory();
            case SlideCategories.COMPARISON:
                return new ComparisonCategory();
            // case SlideCategories.FACTOID:
            //     return new FactoidCategory();
            case SlideCategories.TEXT:
                return new TextCategory();
            case SlideCategories.TITLE:
                return new TitleCategory();
            case SlideCategories.TABLE:
                return new TableCategory();
            case SlideCategories.TIMELINE:
                return new TimelineCategory();
            case SlideCategories.FLOW_DIAGRAM:
                return new FlowDiagramCategory();
            case SlideCategories.BEFORE_AFTER:
                return new BeforeAfterCategory();
            case SlideCategories.PHOTOS_WITH_TEXT:
                return new PhotosWithTextCategory();
            case SlideCategories.TEAM:
                return new TeamCategory();
            case SlideCategories.BIOGRAPHY:
                return new BiographyCategory();
            // case SlideCategories.PRODUCT_SCREENSHOT:
            //     return new ProductScreenshotCategory();
            case SlideCategories.CHART:
                return new ChartCategory();
            case SlideCategories.DASHBOARD:
                return new DashboardCategory();
            case SlideCategories.QUADRANT_CHART:
                return new QuadrantChartCategory();
            case SlideCategories.FUNNEL:
                return new FunnelCategory();
            case SlideCategories.FLOWCHART:
                return new FlowChartCategory();
            case SlideCategories.AGENDA:
                return new AgendaCategory();
            case SlideCategories.TARGET:
                return new TargetCategory();
            case SlideCategories.HIERARCHY_DIAGRAM:
                return new HierarchyDiagramCategory();
            case SlideCategories.CONTACT_INFO:
                return new ContactInfoCategory();
            case SlideCategories.LOGO_GRID:
                return new LogoGridCategory();
            case SlideCategories.VENN_DIAGRAM:
                return new VennDiagramCategory();
            default:
                return new ListCategory();
        }
    }

    static buildCategoryPrompt(excludeTitle = false) {
        const categoryPickerPrompt = Object.values(SlideCategories).map(type => {
            if (excludeTitle && type === SlideCategories.TITLE) {
                return null;
            }
            let category = this.getCategory(type);
            return `
            Category: ${category.type}
            When to use: ${category.description}`;
        }).join("\n");
        return categoryPickerPrompt;
    }
}
